import { initSessionGuard, installSubmitCheck } from './dcms-session-guard.js';

(function() {
  // Every window — the top one and each frame: a form sent long after the last confirmed
  // heartbeat waits until the session guard of the top window has checked the session
  // (dcms-session-guard.js, holdSubmit()).
  installSubmitCheck(window);

  // Check whether we are in the top-level window, not in an iframe
  if (window.top !== window.self) {
    return;
  }

  const guard = initSessionGuard();

  /** When the last refresh was sent (Date.now()). */
  let lastRun = 0;

  // Function that refreshes the session. The response is the classic heartbeat
  // script (`console.log('[sessionRefresh]: ping logged|not-logged…')`), read as
  // text: its status drives the session guard — the sign-in overlay over the page
  // when the session has ended. Read with fetch instead of a <script> tag, so the
  // status reaches no global another site could hook by including the script.
  function DCMS2RefreshSession() {
    lastRun = Date.now();
    fetch('/DCMS2/sessionRefresh.php', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/javascript' },
    })
      .then(function(response) {
        return response.ok ? response.text() : '';
      })
      .then(function(body) {
        const match = /ping (not-logged|logged)/.exec(body || '');
        if (match && guard) {
          guard.heartbeat(match[1]);
        }
      })
      .catch(function() {
        // Network trouble — the next tick tries again.
      });
  }

  // Back at the computer (the tab shown again, the window focused, the network back after
  // sleep, the page restored from the back-forward cache): refresh at once instead of
  // waiting up to 30 s for the next tick — an ended session shows its sign-in overlay
  // before the user gets to "Save". Only when the last refresh is at least 15 s old: the
  // top window also gets `focus` whenever focus moves back from a frame (menu ↔ form),
  // and that alone must not multiply the heartbeat requests.
  function refreshOnReturn() {
    if (Date.now() - lastRun >= 15000) {
      DCMS2RefreshSession();
    }
  }

  // Refresh the session immediately after the page loads
  DCMS2RefreshSession();

  // Set up an interval to refresh the session every 30 seconds
  setInterval(DCMS2RefreshSession, 30000);

  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible') {
      refreshOnReturn();
    }
  });
  window.addEventListener('focus', refreshOnReturn);
  window.addEventListener('online', refreshOnReturn);
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      refreshOnReturn();
    }
  });
})();
